function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 29.66976 29.759528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.802169,-15.00949)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.60733
    },
    d: "m 34.920456,33.810593 c -0.118789,-0.118788 -0.215954,-0.747795 -0.215954,-1.397811 v -1.181849 h -8.170249 -8.170189 v -2.928938 c 0,-1.61092 -0.03468,-3.032994 -0.07709,-3.160171 -0.0424,-0.127181 1.377749,-0.300602 3.155866,-0.385387 l 3.23294,-0.154154 0.188406,-1.164786 c 0.103625,-0.640631 0.452404,-1.359672 0.775078,-1.597866 0.438172,-0.323461 0.498271,-0.522836 0.23743,-0.787662 -0.26292,-0.26694 -0.736466,-0.217054 -1.915888,0.201839 -1.542965,0.548014 -1.57963,0.546758 -2.425542,-0.08307 -2.825233,-2.103489 -0.359429,-6.368884 2.72694,-4.717109 1.005787,0.538281 1.74676,0.579776 2.128983,0.119239 0.197545,-0.238029 0.842308,-0.523412 1.432808,-0.634192 0.837534,-0.157128 1.277824,-0.05046 2.002157,0.485067 0.895483,0.662064 0.974466,0.668938 2.220011,0.193258 1.779236,-0.679494 2.559775,-0.619749 3.44306,0.263534 1.142877,1.142878 1.056373,2.944336 -0.191823,3.994622 -1.070807,0.901026 -1.640593,0.970557 -2.751131,0.335716 -1.46517,-0.837566 -2.593252,-0.230003 -1.404601,0.756491 0.24489,0.203237 0.487684,0.879237 0.539543,1.502221 l 0.09429,1.132691 2.466475,0.157475 c 2.652584,0.169335 3.813726,0.633493 5.12898,2.050259 1.435037,1.545793 1.844016,2.711252 1.744725,4.971897 l -0.0909,2.06966 -2.944212,0.08749 c -1.619318,0.04812 -3.041391,-0.0097 -3.16017,-0.128454 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.60733
    },
    d: "m 36.078263,43.167308 c -1.284285,-1.104699 -1.129006,-2.597197 0.522353,-5.020598 0.737625,-1.082489 1.410513,-1.967006 1.495297,-1.965595 0.08478,0.0016 0.743796,0.923171 1.464469,2.048365 1.555875,2.429211 1.703844,3.73508 0.553553,4.885366 -1.014946,1.014951 -2.888396,1.039302 -4.035672,0.05246 z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefilling);
export default __webpack_public_path__ + "static/media/refilling.23c956acebcc172c381382d642fbba91.svg";
export { ForwardRef as ReactComponent };